import {
  BigDecimal as BigDecimalModule,
  Effect,
  Option,
  Schema,
  SchemaGetter,
  SchemaIssue,
  SchemaTransformation,
} from 'effect';

import { StringRequired } from './string';

export const RequiredStringWithCommaConversion = StringRequired.pipe(
  Schema.decodeTo(StringRequired, {
    encode: SchemaGetter.transform((input) => input),
    decode: SchemaGetter.transform((input) => {
      return input.includes(',') ? input.replace(',', '.') : input;
    }),
  })
);

export const BigDecimal = Schema.BigDecimal.annotate({
  message: 'Hodnota musí být číslo',
});

// v4: `Schema.compose` → `Schema.decodeTo` (per migration/schema.md:19).
// v4's stock `Schema.BigDecimalFromString` transformation rejects bad strings
// with a hard-coded `Invalid BigDecimal string: ...` message that the formatter
// reads from the issue's own annotations (not the schema's), so a top-level
// `.annotate({ message })` does NOT override it. Build a custom string→BigDecimal
// transformation with our localised message embedded on the InvalidValue issue.
const bigDecimalFromCzechString = SchemaTransformation.transformEffect<
  BigDecimalModule.BigDecimal,
  string
>({
  decode: (s) => {
    const parsed = BigDecimalModule.fromString(s);
    return Option.isNone(parsed)
      ? Effect.fail(new SchemaIssue.InvalidValue({ message: 'Hodnota musí být číslo' }))
      : Effect.succeed(parsed.value);
  },
  encode: (bd) => Effect.succeed(BigDecimalModule.format(bd)),
});

export const RequiredStringToBigDecimal = RequiredStringWithCommaConversion.pipe(
  Schema.decodeTo(Schema.BigDecimal, bigDecimalFromCzechString)
);

export const RequiredStringToBigDecimalWithMaxScale = (maximumFractionDigits = 2) =>
  RequiredStringToBigDecimal.check(
    Schema.makeFilter((number) => number.scale <= maximumFractionDigits, {
      message: `Hodnota musí být číslo s maximálně ${String(maximumFractionDigits)} desetinnými místy`,
    })
  );

export const NonNegativeRequiredBigDecimal = (maximumFractionDigits = 2) =>
  RequiredStringToBigDecimalWithMaxScale(maximumFractionDigits).check(
    Schema.isGreaterThanOrEqualToBigDecimal(BigDecimalModule.fromNumberUnsafe(0), {
      message: 'Hodnota musí být kladné číslo',
    })
  );
